import { render, staticRenderFns } from "./ot-organisation-calendar-layout.vue?vue&type=template&id=3925431f&scoped=true&"
import script from "./ot-organisation-calendar-layout.vue?vue&type=script&lang=ts&"
export * from "./ot-organisation-calendar-layout.vue?vue&type=script&lang=ts&"
import style0 from "./ot-organisation-calendar-layout.vue?vue&type=style&index=0&id=3925431f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3925431f",
  null
  
)

export default component.exports